// Line art shared by the policy and price sections. Both inherit currentColor
// so the same mark works on porcelain and on ink.

export function HandIcon({ size = 40, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        d="M419.562,216.775c-7.359-4.221-15.873-6.65-24.949-6.65h-33.539c-8.962,0-17.483,2.391-24.879,6.615
        c-8.218,2.681-16.184,6.145-23.78,10.397l-9.028-4.513c-17.155-8.578-37.389-6.601-52.446,4.578l-59.001-59.001l23.715-23.715
        c6.549-6.549,6.549-17.166,0-23.715L114.526,19.639c-26.155-26.154-68.71-26.153-94.863,0c-26.215,26.214-26.22,68.645,0,94.863
        l101.13,101.13c6.545,6.546,17.169,6.548,23.715,0l23.717-23.717l59.002,59.002c-11.179,15.058-13.157,35.29-4.579,52.447
        l15.811,31.621c1.497,2.994,3.262,5.776,5.243,8.352c-0.002,0.314-0.015,0.631-0.015,0.944v150.926
        c0,9.261,7.508,16.769,16.77,16.769h234.773c9.261,0,16.77-7.508,16.77-16.769V344.281
        C512,284.867,473.173,234.359,419.562,216.775z M132.652,180.058L43.379,90.785c-13.108-13.106-13.109-34.32,0-47.431
        c13.078-13.077,34.355-13.076,47.432,0l89.273,89.273L132.652,180.058z M348.084,319.005
        c11.574-11.573,16.707-27.476,14.086-43.632c-1.662-10.244-6.259-19.399-13.127-26.599c0.454-0.466,0.925-0.916,1.429-1.326
        c8.836-2.491,18.031-3.785,27.372-3.785c9.481,0,18.659,1.32,27.362,3.782c3.766,3.078,6.178,7.755,6.178,12.987v100.617
        c0,9.247-7.523,16.77-16.77,16.77h-33.539c-9.247,0-16.77-7.523-16.77-16.77v-38.266h-0.001L348.084,319.005z M268.456,319.984
        l-15.81-31.621c-3.233-6.464-1.97-14.244,3.141-19.357c1.466-1.467-2.857,2.858,13.245-13.245
        c5.098-5.097,12.873-6.384,19.358-3.141l31.621,15.81c10.251,5.125,12.461,18.755,4.358,26.857l-29.055,29.055
        C287.223,332.431,273.589,330.252,268.456,319.984z M478.461,478.436H277.227V362.404c12.103,1.528,23.784-1.282,33.539-7.645
        v6.29c0,27.74,22.567,50.309,50.309,50.309h33.539c27.74,0,50.309-22.568,50.309-50.309v-91.696
        c20.572,18.436,33.539,45.194,33.539,74.926V478.436z"
      />
      <path
        d="M461.692,109.507h-16.77v-16.77c0-9.261-7.508-16.769-16.77-16.769c-9.261,0-16.769,7.508-16.769,16.769v16.77h-16.77
        c-9.261,0-16.77,7.508-16.77,16.77c0,9.261,7.508,16.769,16.77,16.769h16.77v16.77c0,9.261,7.508,16.77,16.769,16.77
        c9.261,0,16.77-7.508,16.77-16.77v-16.77h16.77c9.261,0,16.769-7.508,16.769-16.769
        C478.461,117.015,470.953,109.507,461.692,109.507z"
      />
      <path
        d="M193.38,377.819H176.61v-16.769c0-9.261-7.508-16.77-16.77-16.77s-16.77,7.508-16.77,16.77v16.769h-16.769
        c-9.261,0-16.77,7.508-16.77,16.77s7.508,16.77,16.77,16.77h16.769v16.769c0,9.262,7.508,16.77,16.77,16.77
        s16.77-7.508,16.77-16.77v-16.769h16.769c9.261,0,16.77-7.508,16.77-16.77S202.641,377.819,193.38,377.819z"
      />
      <circle cx="293.992" cy="126.274" r="16.77" />
    </svg>
  );
}

export function PolishIcon({ size = 40, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        d="M261.562,233.74h-16.695V50.09c0-27.618-22.469-50.086-50.086-50.086h-44.521c-27.618,0-50.086,22.469-50.086,50.086
        v183.65H83.477C37.448,233.74,0,271.188,0,317.218v111.303c0,46.029,37.448,83.477,83.477,83.477h178.085
        c46.029,0,83.477-37.448,83.477-83.477V317.218C345.04,271.188,307.592,233.74,261.562,233.74z M133.564,50.09
        c0-9.206,7.49-16.695,16.695-16.695h44.521c9.206,0,16.695,7.49,16.695,16.695v116.868h-77.912V50.09z M133.564,200.35h77.912
        v33.391h-77.912V200.35z M311.649,428.521c0,27.618-22.469,50.086-50.086,50.086H83.477c-27.618,0-50.086-22.469-50.086-50.086
        V317.218c0-27.618,22.469-50.086,50.086-50.086h33.391h111.303h33.391c27.618,0,50.086,22.469,50.086,50.086V428.521z"
      />
      <path
        d="M261.562,300.522H83.477c-9.22,0-16.695,7.475-16.695,16.695v111.303c0,9.22,7.475,16.695,16.695,16.695h178.085
        c9.22,0,16.695-7.475,16.695-16.695V317.218C278.258,307.997,270.783,300.522,261.562,300.522z M244.867,411.826H100.173v-77.912
        h144.694V411.826z"
      />
      <path
        d="M511.598,491.68l-15.017-67.577c-4.719-21.237-20.318-37.406-40.237-43.269V267.131H495.3
        c9.22,0,16.695-7.475,16.695-16.695V50.09c-0.001-27.618-22.47-50.086-50.088-50.086h-44.521
        c-27.618,0-50.086,22.469-50.086,50.086v200.346c0,9.22,7.475,16.695,16.695,16.695h38.956v113.703
        c-19.918,5.863-35.517,22.032-40.236,43.269l-15.017,67.577c-2.315,10.414,5.619,20.317,16.298,20.317H495.3
        C505.967,511.997,513.916,502.105,511.598,491.68z M400.691,50.09c0-9.206,7.49-16.695,16.695-16.695h44.521
        c9.206,0,16.695,7.49,16.695,16.695v116.868h-77.912V50.09z M400.691,233.74V200.35h77.912v33.391H400.691z M404.808,478.606
        l10.503-47.259c2.554-11.495,12.563-19.523,24.336-19.523c11.775,0.001,21.782,8.028,24.336,19.523l10.503,47.259H404.808z"
      />
    </svg>
  );
}
